import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import vuetify from "./plugins/vuetify";
import globalMixin from "./mixins";
import VueMask from "v-mask";
import VueRouter from "vue-router";
import router from "./router";
import moment from "moment";
import VueI18n from "vue-i18n";
import i18n from "./i18n";
// require("moment/locale/th");
Vue.config.productionTip = false;
Vue.use(globalMixin);
Vue.use(VueMask);
Vue.use(VueRouter);
Vue.use(VueI18n);
Vue.prototype.moment = moment;

//use language from the rouing param
router.beforeEach((to, from, next) => {

  let language = to.params.lang;
  if (!language) {
    language = "en"
  }

  i18n.locale = language
  next()
})
new Vue({
  store,
  vuetify,
  router,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
